<template>
    <v-container class="cmpbk black--text" id="home-container">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->
        <div>Logs ATLS</div>
    </v-container>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "Home ATLS",
        mixins: [bus_common],
        data() {
            return {};
        },
        methods: {
            message1() {
                alert("This button does nothing yet.");
            },
            init() { },
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
